import { createWorkflowRunner } from './workflow-runner'
import WorkflowRunnerError from './workflow-runner-error'

const DEFAULT_EXECUTION_MODE = 'single'

const validateExecutionMode = (compiledFlow, context) => {
    const mode = context && context.mode ? context.mode : DEFAULT_EXECUTION_MODE
    const unsupportedSteps = compiledFlow.steps
        .filter(step => step.enabled)
        .filter(step => !step.descriptor.capabilities.supportedModes.includes(mode))
        .map(step => step.id)

    if (unsupportedSteps.length > 0) {
        throw new WorkflowRunnerError(
            'STEP_EXECUTION_MODE_NOT_SUPPORTED',
            `Workflow steps do not support execution mode "${mode}": ${unsupportedSteps.join(', ')}`,
            { mode, unsupportedSteps },
        )
    }
}

const bootstrapWorkflowRunner = async ({
    compiledFlow,
    context = {},
    progressRepository,
}) => {
    validateExecutionMode(compiledFlow, context)

    if (!progressRepository || typeof progressRepository.getProgress !== 'function') {
        throw new WorkflowRunnerError(
            'INVALID_PROGRESS_REPOSITORY',
            'Workflow bootstrap requires progressRepository.getProgress()',
        )
    }

    const progress = await progressRepository.getProgress()

    if (
        !progress
        || !Array.isArray(progress.completedStepIds)
        || !Array.isArray(progress.completedLegacyPersistedSteps)
    ) {
        throw new WorkflowRunnerError(
            'INVALID_WORKFLOW_PROGRESS',
            'Progress repository must return completed step id arrays',
            { progress },
        )
    }

    const runner = createWorkflowRunner({
        compiledFlow,
        context,
        completedStepIds: progress.completedStepIds,
        completedLegacyPersistedSteps: progress.completedLegacyPersistedSteps,
        progressRepository,
    })

    // Start mounted controller loading, but let the host render the initial runtime state
    // instead of blocking the whole manifest page until controller data is ready.
    runner.initialize().catch(() => undefined)

    return runner
}

export { bootstrapWorkflowRunner }
export default bootstrapWorkflowRunner
